export const user = state => state.user
export const userId = state => (state.user && state.user.id ? state.user.id : null)
export const token = state => (state.token ? state.token : localStorage.getItem('token') ? localStorage.getItem('token') : null)
export const roles = state => (state.roles && state.roles.length ? state.roles : ['guest'])
export const hasRole = (state, getters) => role => getters.roles.includes(role)
export const isAdmin = (state, getters) => getters.hasRole('Admin')
export const hasAnyRole = (state, getters) => checkRoles => checkRoles !== undefined && Array.isArray(checkRoles) ? checkRoles.some(checkRole => getters.hasRole(checkRole)) : false
export const expires = state => state.expires
export const auth = (state, getters) => {
  const { roles, token, user, userId } = getters
  return { roles, token, user, userId }
}
